<template lang="pug">
#page_content.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		h1 404
		h3 很抱歉，系統內沒有您指定的頁面。
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_1.jpg',
				title: '404 (找不到網頁) 錯誤',
			},
		};
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content
	.article
		padding: 6rem
</style>
